import React from "react";
import { Input } from "antd";

/**
 * Link-generation tab: an optional email-domain restriction plus an explanatory
 * warning. Presentational — the container owns `domainRestriction` state.
 *
 * @param {object} props
 * @param {string} props.domainRestriction
 * @param {(value: string) => void} props.onChange
 */
export default function LinkGenerationTab({ domainRestriction, onChange }) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <label className="text-[#3f3f46] text-sm font-bold font-['Inter']">
            Allowed Email Domain
          </label>
          <span className="text-xs text-gray-500 font-['Inter']">
            Optional — leave blank to allow any email
          </span>
        </div>
        <Input
          value={domainRestriction}
          onChange={(e) => onChange(e.target.value)}
          placeholder="e.g. company.com"
          addonBefore={<span className="text-gray-400 select-none">@</span>}
          style={{ borderRadius: "8px" }}
          size="large"
        />
        <p className="text-xs text-gray-400 font-['Inter'] mt-0.5">
          Only users with a matching email domain can register via this link.
        </p>
      </div>
      <div className="flex items-start gap-3 p-3 bg-amber-50 border border-amber-200 rounded-lg">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="text-amber-500 mt-0.5 shrink-0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        <p className="text-xs text-amber-700 font-['Inter']">
          The generated link can be shared directly — no email required. Anyone with the link (and matching domain) can create an account with the role and scope configured below.
        </p>
      </div>
    </div>
  );
}
